module.exports = __webpack_public_path__ + "static/media/family-group.451de5ef.png";